<script setup lang="ts" generic="T">
import { computed } from 'vue';
import FormLabel from '../FormLabel/FormLabel.vue';

const props = defineProps<{
  groups?: Record<string, T[]>;
}>();

const numGroups = computed(() => (props.groups ? Object.keys(props.groups).length : 0));
</script>

<template>
  <div v-for="(group, name, index) in groups" :key="name">
    <FormLabel v-if="numGroups > 1" class="text-h6 text-primary">
      {{ $t('Group_one') }}: {{ name }}
    </FormLabel>

    <slot name="default" :items="group" :groupIndex="index" :groupName="name" :groups="groups" />
  </div>
</template>
